export const aircraftTypesFilters = {
    'name': {
        'inputType': 'text',
        'title': 'Name',
    },
    'aircraft_family': {
        'inputType': 'dropdown',
        'title': 'Aircraft Family',
        'options': [],
        'labelKey': 'name',
        'valueKey': 'id',
    },
    'aircraft_body_type': {
        'inputType': 'dropdown',
        'title': 'Aircraft Body Type',
        'options': [],
        'labelKey': 'label',
        'valueKey': 'label',
    },
        'has_propeller': {
        'inputType': 'checkbox',
        'title': 'Has Propeller',
        'labelKey': 'label',
        'valueKey': true, 
    },
    'has_apu': {
        'inputType': 'checkbox',
        'title': 'Has APU',
        'labelKey': 'label',
        'valueKey': true, 
    },
}; 